export default __webpack_public_path__ + "roboto-v29-latin-700.woff";